<script setup lang="ts">
    import { useDisplay, useTheme } from 'vuetify';
    import { useAppStore } from '#imports';

    /* Store variables */
    const { brandIcon, isMobile, siteName, tagLine } = storeToRefs(useAppStore());

    /* Private variables */
    const _display = useDisplay();
    const _theme = useTheme();

    isMobile.value = computed(() => { return _display.mobile.value; });
    _theme.global.name.value = 'theme_light';
</script>

<template>
    <v-app-bar class="justify-left" style="background: linear-gradient(90deg, rgb(var(--v-theme-surfaceLight)), transparent) !important; backdrop-filter: blur(8px);">
        <v-card-title style="width: fit-content"
            class="cursor-pointer"
            @click="navigateTo('/')">
            <div>
                <p class="brand-font color-primary mb-n1 d-flex align-end">
                    <v-icon :icon="brandIcon" color="primary" />
                    {{ siteName }}
                </p>
                <p class="text-caption color-secondary font-italic">{{ tagLine }}</p>
            </div>
        </v-card-title>
        <v-spacer />
        <LoginLogInOutBtn />
        <!--
        <v-btn
            class="text-caption"
            color="primary"
            style="margin-inline: 0 !important; background: transparent;"
            variant="plain">
            Home
        </v-btn>
        <v-btn
            class="text-caption"
            color="primary"
            style="margin-inline: 0 !important; background: transparent;"
            variant="plain">
            Pricing
        </v-btn>
        <v-btn
            class="text-caption"
            color="primary"
            style="margin-inline: 0 !important; background: transparent;"
            variant="plain">
            Contact
        </v-btn>
        -->
    </v-app-bar>
</template>